import { Modal, ModalBody } from "@vds/modals";
import { Icon } from "@vds/icons";
import { Title } from "@vds/typography";
import { useState, useEffect, useContext } from "react";
import { SLButton } from "../../components/core/Controls";
import { FlexRow, SLGridLayout, SLRowLayout, CompactCol } from "../../components/core/Utility/index";
import { css } from "@emotion/react";
import styled from "styled-components";
import { ValidateAddressWT } from "./ValidateAddressWT";
import { Input } from "@vds/inputs";
import { EMAIL_REGEX_C360 } from "../../constants/ValidationConstants";
import { C4SContext } from "../../context/c4sContext";
import { workticketUpdate } from "../../services/C4S Decommission - Replacement/workticketUpdate ";
import { Loader } from "@vds/loaders";
import { generate } from "shortid";
import useOutsideClick from "../../customHook/use-outside-click";
import { SLNotification } from "../../components/core/utility";
import { switchTab } from "./utils";

export const CustomNotification = styled(SLNotification)`
  & div {
    justify-content: flex-start;
    max-width: 100%;
    & span:first-child {
      flex: 20 1 0%;
    }
  }
`;

export const CustomInput = styled(Input)`
  padding-bottom: 0.5rem;
  height: auto;
  & label {
    & p {
      font-size: 12px;
      font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "400")};
      color: ${(props) => (props.disabled ? "#d8dada" : "")};
    }
  }
  & span {
    & span {
      & span {
        width: ${(props) => (props.boxWidth ? props.boxWidth : "")};
      }
    }
  }
  & input {
    font-size: 12px;
    height: ${(props) => (props.height ? props.height : "")};
    &:disabled {
      -webkit-text-fill-color: #000000;
      background-color: #ffffff;
      border-bottom: 1px solid #000000;
      border-top: 1px solid #dfe0e0;
      color: ${(props) => (props.disabled ? "#d8dada" : "")};
      opacity: ${(props) => (props.disabled ? "0.4" : "")};
    }
  }
  & span {
    width: ${(props) => (props.width ? props.width : "")};
    & span {
      & span {
        & div:not(:first-child) {
          & svg {
            display: none; // hide success tick icon
          }
        }
      }
    }
  }
`;

export const StyledModal = css`
  max-height: 120vmin;
  padding: 1rem 1rem 1rem 1rem;
  padding-right: 2px;
  width: 40vw;
  z-index: 10000 !important; /* Ensure this modal stays above other modals */
  @media (max-width: 767px) {
    width: 560px !important;
    height: auto;
    min-height: 14.5rem;
    padding: 1rem 1rem 1rem 1rem;
    padding-right: 2px;
  }

  & footer {
    padding: 0;
  }
`;

const UpdateAddressContactModal = ({ setIsAddressUpdateModal, ticketDetails, onAddressUpdated, shouldOpenReturnReship, initialFlags }) => {
  const [isLoading, setLoader] = useState(false);
  const [notification, setNotification] = useState(null);
  const [address, setAddress] = useState({
    verified: false,
    addressByPass: null,
    locationFound: null,
    timezone: "",
    latitude: "",
    longitude: "",
    locusSuggestedAddress: "",
    historicalAddress: { value: "", error: false, errorText: "", success: false },
    address1: { value: "", error: false, errorText: "Enter valid street address", success: false },
    address2: { value: "", error: false, errorText: "Enter address 2", success: false },
    city: { value: "", error: false, errorText: "Enter city", success: false },
    country: { value: null, options: [], error: false, errorText: "Please select country", success: false },
    state: { value: null, options: [], allStateOptions: null, error: false, errorText: "Please select state", success: false },
    zip: { value: "", error: false, errorText: "Enter zip code", success: false },
    isDefaultAddress: true,
  });
  const [name, setName] = useState({
    value: "",
    error: false,
    errorText: "Enter name",
    success: false,
  });
  const [phone, setPhone] = useState({
    value: "",
    error: false,
    errorText: "Enter phone",
    success: false,
  });
  const [email, setEmail] = useState({
    value: "",
    error: false,
    errorText: "Enter email",
    success: false,
  });

  const { cspDetails } = useContext(C4SContext);
  const [isSaveBtnDisabled, setIsSaveBtnDisabled] = useState(true);

  useEffect(() => {
    if (address.verified && name.success && phone.success && email.success && !address.isDefaultAddress) {
      setIsSaveBtnDisabled(false);
    } else if (address.verified && name.success && phone.success && email.success && address.isDefaultAddress) {
      if (cspDetails.cspDetails.cspData?.data?.data?.CSP.length > 0) {
        let cspContactDetails = cspDetails.cspDetails.cspData.data.data;
        if (
          name.value !== cspContactDetails.CSP[0].CSPContactName ||
          email.value !== cspContactDetails.CSP[0].CSPContactEmail ||
          phone.value !== cspContactDetails.CSP[0].CSPContactPhone
        ) {
          setIsSaveBtnDisabled(false);
        } else {
          setIsSaveBtnDisabled(true);
        }
      }
    } else {
      setIsSaveBtnDisabled(true);
    }
  }, [address.verified, name.success, phone.success, email.success, address.isDefaultAddress, name.value, phone.value, email.value]);

  useEffect(() => {
    if (cspDetails.cspDetails.cspData?.data?.data?.CSP.length > 0) {
      let cspContactDetails = cspDetails.cspDetails.cspData.data.data;
      handleFields("Name", cspContactDetails.CSP[0].CSPContactName);
      handleFields("Email", cspContactDetails.CSP[0].CSPContactEmail);
      handleFields("Phone", cspContactDetails.CSP[0].CSPContactPhone);
    } else {
      let cspContactDetails = cspDetails.cspDetails.cspData.data.data;
      handleFields("Name", cspContactDetails.CASEDetails[0].CSPContactName);
      handleFields("Email", cspContactDetails.CASEDetails[0].CSPContactEmail);
      handleFields("Phone", cspContactDetails.CASEDetails[0].CSPContactPhone);
    }
  }, []);

  const handleClickOutside = () => {
    setNotification(null);
  };

  const clickRef = useOutsideClick(handleClickOutside);

  const notify = (content, type, isNotificationWithTimer = true) => {
    setNotification(
      <>
        <CustomNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />
      </>
    );
    if (isNotificationWithTimer) {
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
  };

  const handleFields = (field, value) => {
    switch (field) {
      case "Name": {
        if (value && value.length) {
          setName({ value, error: false, errorText: "Enter name", success: true });
        } else {
          setName({ value: "", error: true, errorText: "Enter name", success: false });
        }
        break;
      }
      case "Phone": {
        let phoneRegex = /^([^a-zA-Z])+$/;
        if (value && value.length) {
          if (phoneRegex.test(value)) {
            setPhone({ value, error: false, errorText: "Enter phone number", success: true });
          }
        } else {
          setPhone({ value: "", error: true, errorText: "Enter phone number", success: false });
        }
        break;
      }
      case "Email": {
        if (value && value.length) {
          if (EMAIL_REGEX_C360.test(value)) {
            setEmail({ value, error: false, errorText: "Enter email", success: true });
          } else {
            setEmail({ value, error: true, errorText: "Enter a valid email", success: false });
          }
        } else {
          setEmail({ value: "", error: true, errorText: "Enter email", success: false });
        }
        break;
      }
    }
  };

  const handleSaveData = async () => {
    // Check if ticketDetails is available
    if (!ticketDetails) {
      notify("Unable to update address - ticket details are missing", "error");
      setLoader(false);
      return;
    }
    const payload = {
      modifiedBy: `${cspDetails.cspDetails?.firstName} ${cspDetails.cspDetails?.lastName}`,
      modifiedByEmail: cspDetails.cspDetails.cspData?.data?.data?.email || "",
      modifiedByEid: cspDetails.cspDetails.cspData?.data?.data?.Employee_ID || "",
      address: {
        address1: address.address1.value,
        address2: address.address2.value,
        city: address.city.value,
        country: address.country.value.description,
        countryCode: address.country.value.code,
        stateCode: address.state.value.erpStateCode,
        zipCode: address.zip.value,
        addressByPass: address.addressByPass,
        locationFound: address.locationFound,
        locusSuggestedAddress: address.locusSuggestedAddress,
        latitude: address.latitude,
        longitude: address.longitude,
        timezone: address.timezone,
        locusLocationId: address.locusLocationId,
        createdBy: `${cspDetails.cspDetails.firstName} ${cspDetails.cspDetails.lastName}`,
      },
      contact: {
        customerName: name.value,
        customerEmail: email.value,
        customerPhone: phone.value,
        createdBy: `${cspDetails.cspDetails.firstName} ${cspDetails.cspDetails.lastName}`,
      },
      workTicketId: ticketDetails?.ticketId || "",
      documentType: cspDetails.cspDetails.cspData?.data?.data?.CSP[0].CSPID !== "" ? "ZINS" : "ZSRQ",
      resellerBusinessPartnerNumber:
        cspDetails.cspDetails.cspData?.data?.data?.ResellerBusinessPartnerNumber ||
        cspDetails.cspDetails.cspData?.data?.data?.ERP_Partner_Number ||
        "", // ResellerBusinessPartnerNumber
      erpBusinessPartnerId:
        cspDetails.cspDetails.cspData?.data?.data?.ResellerBusinessPartnerNumber || cspDetails.cspDetails.cspData?.data?.data?.ERP_Partner_Number,
      erpPrimaryContactNumber: cspDetails.cspDetails.cspData?.data?.data?.ERP_Primary_Contact_NUmber ?? "",
      accountName: cspDetails.cspDetails.cspData?.data?.data?.AccountName,
    };
    // Check if initialFlags.source is 'commonModal' - skip API call
    if (initialFlags?.source === "commonModal") {
      notify("Address details validated successfully", "success");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
      setIsAddressUpdateModal(false);

      // Send entire payload back to wtcCommonModal
      if (onAddressUpdated) {
        const flagsToSendBack = {
          openReturnReship: shouldOpenReturnReship || true,
          addressUpdateSuccess: true,
          payload: payload, // Include the entire payload
          customAction: "proceedToReturnReship",
          source: initialFlags?.source || "updateAddressModal",
          apiSkipped: true, // Flag to indicate API was skipped
        };

        onAddressUpdated(flagsToSendBack);
      }
      return;
    }

    setLoader(true);

    let response = await workticketUpdate(payload);
    if (response?.status === 200 && response?.data) {
      if (response?.data?.data?.updateStatus) {
        // Persist notification and auto-close modal after a short delay
        notify(response?.data?.data?.message, "success", false);
      } else {
        notify(response?.data?.data?.message || "Update failed", "error", false);
      }
      setIsSaveBtnDisabled(true);
      setTimeout(() => {
        setNotification(null);
        setIsAddressUpdateModal(false);
        switchTab(3);
      }, 3000);
    } else {
      // Keep modal open to show error notification
      notify("We are currently experiencing issues, please try again", "error", false);
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
    setLoader(false);
  };

  return (
    <div>
      <Loader active={isLoading} fullscreen />
      <Modal
        id="Reschedule Reason Modal"
        ariaLabel="Reschedule Reason Modal"
        opened={true}
        fullScreenDialog={false}
        disableOutsideClick={true}
        css={StyledModal}
        closeButton={
          <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
            <div>
              <Title size="medium">Shipping Address & Contact</Title>
            </div>
            <div onClick={() => setIsAddressUpdateModal(false)} css={{ marginRight: "1rem", marginTop: "0.3rem" }}>
              <Icon
                role="img"
                aria-label="close"
                alt="close-icon"
                name="close"
                size="medium"
                color="#000000"
                style={{ cursor: "pointer", outline: "none" }}
              />
            </div>
          </FlexRow>
        }
      >
        <ModalBody css={{ paddingLeft: "0", paddingRight: "0" }}>
          {/* <Spacer top=".5rem" /> */}
          {notification}
          <ValidateAddressWT
            address={address}
            setAddress={setAddress}
            showHistoricalAddressDropdown={true}
            notify={notify}
            shippingAddress={[
              ticketDetails.addressOne,
              ticketDetails.addressTwo,
              ticketDetails.city,
              ticketDetails.stateCode,
              ticketDetails.zipCode,
              ticketDetails.country,
            ]
              .filter((item) => item !== null && item !== "")
              .join(", ")}
          />
          <SLGridLayout>
            <SLRowLayout css={{ marginTop: ".5rem", paddingLeft: "10px !important" }}>
              <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 13 }}>
                <CustomInput
                  type="text"
                  label="Contact Name*"
                  aria-label="Contact Name"
                  error={name.error}
                  errorText={name.errorText}
                  success={name.success}
                  value={name.value}
                  maxLength={50}
                  css={{ paddingRight: "10px" }}
                  onChange={(event) => handleFields("Name", event.target.value, "")}
                />
              </CompactCol>
              <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 13 }}>
                <CustomInput
                  type="text"
                  label="Phone Number*"
                  aria-label="Phone Number"
                  error={phone.error}
                  errorText={phone.errorText}
                  success={phone.success}
                  value={phone.value}
                  css={{ paddingRight: "10px" }}
                  onChange={(event) => handleFields("Phone", event.target.value, "")}
                />
              </CompactCol>
              <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 13 }}>
                <CustomInput
                  type="text"
                  label="Email*"
                  aria-label="Email"
                  error={email.error}
                  errorText={email.errorText}
                  success={email.success}
                  value={email.value}
                  css={{ paddingRight: "10px" }}
                  onChange={(event) => handleFields("Email", event.target.value, "")}
                />
              </CompactCol>
            </SLRowLayout>
          </SLGridLayout>
        </ModalBody>
        <FlexRow css={{ justifyContent: "flex-end" }}>
          <SLButton size="large" secondary aria-label="Cancel" role="button" css={{ width: "10rem" }} onClick={() => setIsAddressUpdateModal(false)}>
            Cancel
          </SLButton>
          <SLButton
            aria-label="Save"
            role="button"
            size="large"
            css={{ width: "10rem" }}
            onClick={() => {
              handleSaveData();
            }}
            disabled={isSaveBtnDisabled}
            ariaDisabled={isSaveBtnDisabled}
          >
            Save
          </SLButton>
        </FlexRow>
      </Modal>
    </div>
  );
};

export default UpdateAddressContactModal;
